<template>
  <div v-if="data" :class="'notif-box ' + anchor + ' ' + data.color">
    {{ data.text }}
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
    anchor: {
      type: String,
      default: 'top'
    }
  },
  mounted() {
    setTimeout(
      function() {
        this.$emit('update:data', null);
      }.bind(this),
      3000
    );
  }
};
</script>

<style scoped>
@keyframes fade-in-out {
  0% {
    opacity: 0;
  }
  10%,
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.notif-box {
  animation: fade-in-out 3s ease both;
  position: fixed;
  z-index: 1;
  padding: 10px;
  width: auto;
  height: auto;
  border-radius: 4px 4px 4px 4px;
  color: white;
  font-size: 1rem;
}
.bottom {
  right: 10px;
  bottom: 10px;
}
.top {
  right: 10px;
  top: 10px;
}
.green {
  background-color: #36d7b7;
}
.red {
  background-color: #cf000f;
}
@media screen and (max-width: 640px) {
  .top {
    top: 50px;
  }
}
</style>
